import type { StreamingConfiguration } from '@sgme/signalr';
import type { ISGWTConnectConfiguration } from '@sgwt/connect-core';

export interface AppConfiguration {
  env: 'local' | 'devci' | 'uatrc' | 'production';
  api_uri: string;
  redirect_uri: string;
  sgconnect: ISGWTConnectConfiguration;
  streaming: StreamingConfiguration;
}

export const appConfig: AppConfiguration = window.sgmeConfiguration;

export const isProductionEnv = appConfig.env === 'production';

export const isHomologationEnv = !isProductionEnv;

export const applicationId = 'sgmarkets-mytreso';

export const helpCenterId = 'myTreso-help-center';
